import { ButtonHTMLAttributes } from "react";
import { Link } from "react-router-dom";

import GoogleIcon from "../../assets/icons/GoogleIcon";
import { cn } from "../../utils/styling";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: "primary" | "secondary" | "tertiary" | "google";
  size: "default" | "small";
  fullWidth?: boolean;
  as?: "button" | "link";
  to?: string;
};

export function Button({
  children,
  variant,
  fullWidth,
  disabled,
  size,
  as = "button",
  to,
  ...props
}: ButtonProps) {
  const buttonClasses = cn(
    "cursor-pointer text-center rounded-full  inline-flex items-center justify-center gap-2",
    {
      "bg-brand-primary-darker text-white hover:text-gray-100 hover:bg-brand-primary-darker/80":
        variant === "primary",
      "bg-surface-one text-black hover:bg-surface-two": variant === "secondary",
      "bg-white border border-gray-400 border-1 text-black hover:text-foreground-secondary":
        variant === "google",
      "bg-white/0 text-foreground-primary hover:text-foreground-secondary":
        variant === "tertiary",
      "w-full": fullWidth,
      "opacity-50": disabled,
      "px-12 py-2": size === "default",
      "px-4 py-2 text-sm": size === "small",
    },
  );

  let buttonContent = children;

  if (variant === "google") {
    buttonContent = (
      <>
        <GoogleIcon />
        {children}
      </>
    );
  }
  if (as === "link" && to) {
    return (
      <Link
        to={to}
        className={buttonClasses}
        style={{ textDecoration: "none" }}
        {...(props as any)}
      >
        {buttonContent}
      </Link>
    );
  }

  return (
    <button className={buttonClasses} {...props}>
      {buttonContent}
    </button>
  );
}
